import React, { useEffect, useRef } from "react";
import { Niivue } from "@niivue/niivue";

/**
 * Affiche soit une <img>, soit un volume Niivue pleine page.
 * Props :
 *  - img     : { url, name, isVolume }
 *  - onClose : () => void
 */
const ModalViewer = ({ img, onClose }) => {
  const canvasRef = useRef(null);
  const nvRef     = useRef(null);

  useEffect(() => {
    const key = e => e.key === "Escape" && onClose();
    window.addEventListener("keydown", key);
    return () => window.removeEventListener("keydown", key);
  }, [onClose]);

  useEffect(() => {
    if (!img.isVolume) return;

    const nv = new Niivue({ dragMode: "contrast" });
    nv.attachToCanvas(canvasRef.current);
    nv.loadVolumes([{ url: img.url, name: img.name }]).then(() => {
      nv.setSliceType(nv.sliceTypeMultiplanar);
      nv.drawScene();
    });
    nvRef.current = nv;

    return () => {
      const nv = nvRef.current;
      if (!nv) return;

      if (typeof nv.dispose === "function") {
        nv.dispose();
      } else if (typeof nv.cleanup === "function") {
        nv.cleanup();
      } else if (typeof nv.destroy === "function") {
        nv.destroy();
      }
    
      nvRef.current = null;
    };
  }, [img]);

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center
                 bg-black/80 backdrop-blur"
      onClick={onClose}
    >
      <div onClick={e => e.stopPropagation()} className="max-w-5xl w-full p-4">
        {/* HEADER */}
        <div className="flex justify-between mb-2 text-gray-100">
          <span className="font-medium truncate">{img.name}</span>
          <div className="space-x-4">
            <a
              href={img.url}
              download={img.name}
              className="underline text-sm"
            >
              Télécharger
            </a>
            <button onClick={onClose} className="text-xl leading-none">✕</button>
          </div>
        </div>

        {/* CONTENU */}
        {img.isVolume ? (
          <canvas ref={canvasRef} className="w-full h-[75vh] rounded-lg" />
        ) : (
          <img
            src={img.url}
            alt={img.name}
            className="w-full max-h-[75vh] object-contain rounded-lg"
          />
        )}
      </div>
    </div>
  );
};

export default ModalViewer;
